
import { useEffect } from 'react';

const useScrollToHash = (...deps: unknown[]) => {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const scrollToHash = () => {
            const { hash } = window.location;
            if (!hash) {
                return;
            }
            const targetElement = document.querySelector(hash);
            if (targetElement instanceof HTMLElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        const timeoutId = window.setTimeout(scrollToHash, 100);
        window.addEventListener('hashchange', scrollToHash);

        return () => {
            window.clearTimeout(timeoutId);
            window.removeEventListener('hashchange', scrollToHash);
        };
    }, deps);
};

export default useScrollToHash;
